import { Box, Button, Tooltip } from '@televet/kibble-ui';
import { BaseEmoji, Picker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import { IKeyboardShortcutElementRefs } from 'pages/Conversations/interfaces/IKeyboardShortcutElementRefs';
import React, { useCallback, useEffect, useRef } from 'react';
import { useTracking } from 'shared/providers/TrackingProvider';
import { ConversationEvents } from 'shared/providers/TrackingProvider/EventNames';

interface EmojiPickerModalProps {
  isEmojiPickerOpen: boolean;
  onEmojiSelect: (emoji: BaseEmoji) => void;
  setIsEmojiPickerOpen: (value: boolean) => void;
  shortcuts: IKeyboardShortcutElementRefs;
}

const EmojiPickerModal: React.FC<EmojiPickerModalProps> = ({
  isEmojiPickerOpen,
  onEmojiSelect,
  setIsEmojiPickerOpen,
  shortcuts,
}) => {
  const emojiPickerRef = useRef<HTMLDivElement | null>(null);
  const { trackEvent } = useTracking();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function handleClickOutside(event: any): void {
      if (!emojiPickerRef.current?.contains(event.target)) {
        setIsEmojiPickerOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return (): void => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [emojiPickerRef, setIsEmojiPickerOpen]);

  const emojiPickerToggle = useCallback((): void => {
    setIsEmojiPickerOpen(!isEmojiPickerOpen);

    trackEvent(ConversationEvents.ChannelEmojiDrawerOpen);
  }, [isEmojiPickerOpen, trackEvent, setIsEmojiPickerOpen]);

  useEffect(() => {
    shortcuts.subscribe('e', emojiPickerToggle);
    return (): void => {
      shortcuts.unsubscribe('e', emojiPickerToggle);
    };
  }, [emojiPickerToggle, shortcuts]);

  return (
    <>
      {isEmojiPickerOpen && (
        <Box ref={emojiPickerRef}>
          <Picker
            autoFocus
            native
            title="Pick your emoji…"
            emoji="point_up"
            style={{ position: 'absolute', bottom: 30, right: 180, zIndex: 1 }}
            onSelect={onEmojiSelect}
          />
        </Box>
      )}
      <Tooltip label="Emojis">
        <Box onClick={emojiPickerToggle}>
          <Button iconName="smileyFace" variant="ghostNeutral" />
        </Box>
      </Tooltip>
    </>
  );
};

export default EmojiPickerModal;
